import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useAuth } from "../utils/AuthHooks";
import { CountdownTimerWithReset } from "../components/ui/CountdownTimer";

function LoginPage() {
  const [form, setForm] = useState({ username: "", password: "" });
  const [otpForm, setOtpForm] = useState({ code: "" });

  const auth = useAuth();

  let history = useHistory();

  const changeField = (field, value) => {
    setForm({ ...form, [field]: value });
  };

  const formLoginSubmit = async (event) => {
    event.preventDefault();
    auth.login(form);
  };

  const formOtpSubmit = async (event) => {
    event.preventDefault();
    auth.verify(otpForm);
  };

  const cancelOtp = () => {
    setForm({ ...form, password: "" });
    setOtpForm({ ...otpForm, code: "" });
    auth.cancelVerify();
  };

  useEffect(() => {
    if (auth.isAuthenticated) {
      history.push("/home");
    }
  }, [auth.isAuthenticated, history]);

  return (
    <div
      className="login-page-wrapper bg-gradient-primary"
      style={{ minHeight: "100vh", padding: "100px 0" }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6">
            <div className="card o-hidden border-0 shadow-lg">
              <div className="card-body p-5">
                <div className="row">
                  <div className="col-12">
                    <div className="text-center mb-5">
                      {/* <img src={image} className="mb-3" style={{maxWidth: "200px"}}/> */}
                      <h1 className="h4 text-gray-900 mb-4">Login Dashboard</h1>
                    </div>
                  </div>
                  <div className="col-12">
                    {auth.errorMsg && <div className="alert alert-danger">{auth.errorMsg}</div>}
                    {auth.twoFactor?.need_verification === null ? (
                      <form className="user" onSubmit={(event) => formLoginSubmit(event)}>
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control form-control-user"
                            id="username"
                            aria-describedby="usernameHelp"
                            value={form.username}
                            onChange={(event) => changeField("username", event.target.value)}
                            placeholder="Enter username ..."
                          />
                        </div>
                        <div className="form-group">
                          <input
                            type="password"
                            className="form-control form-control-user"
                            id="password"
                            value={form.password}
                            onChange={(event) => changeField("password", event.target.value)}
                            placeholder="Password"
                          />
                        </div>
                        <button
                          type="submit"
                          className="btn btn-primary btn-user btn-block"
                          disabled={auth.status === "login"}
                        >
                          {auth.status === "login" ? "Login ...." : "Login"}
                        </button>
                      </form>
                    ) : null}
                  </div>

                  {auth.twoFactor?.need_verification && (
                    <div className="col-12">
                      <form className="user" onSubmit={(event) => formOtpSubmit(event)}>
                        <div className="form-group">
                          <label htmlFor="otp-input">Verifikasi OTP</label>
                          <input
                            type="text"
                            name="otp-input"
                            id="otp-input"
                            placeholder="OTP"
                            className="form-control form-control-user"
                            value={otpForm.code}
                            onChange={(event) =>
                              setOtpForm({ ...otpForm, code: event.target.value })
                            }
                          />
                          <small id="otp-input-help" class="form-text">
                            Silakan periksa email Anda di <b>{auth.twoFactor.email}</b> untuk kode
                            OTP
                          </small>
                        </div>
                        <CountdownTimerWithReset
                          unix_time={auth.twoFactor.valid_time}
                          cancelOtp={cancelOtp}
                        />
                        <button
                          className="btn btn-primary btn-user btn-block"
                          disabled={auth.status === "verifying"}
                        >
                          {auth.status === "verifying" ? "Memverfikasi ..." : "Verifikasi"}
                        </button>
                      </form>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
